// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"99e325d3","4596":"99e325d3","6407":"3c9f5b83","6868":"83ac2be7","7028":"3c9f5b83"}[chunkId] + ".chunk.css";
};